// extracted by mini-css-extract-plugin
export default {"titleFlex":"Collapse_titleFlex__Y++Cy"};